import { match } from 'ts-pattern';

import { HTMLAttributes } from 'react';

import { Table } from '@ingrid/luterkort-react';

type TableRootProps = HTMLAttributes<HTMLTableElement>;

type SectionProps = HTMLAttributes<HTMLTableSectionElement>;

type RowProps = HTMLAttributes<HTMLTableRowElement>;

type CellProps = HTMLAttributes<HTMLTableCellElement> & {
  as?: 'th' | 'td';
};

function TableRoot({ children, ...rest }: TableRootProps) {
  return <Table.Table {...rest}>{children}</Table.Table>;
}

function Head({ children, ...rest }: SectionProps) {
  return <thead {...rest}>{children}</thead>;
}

function Body({ children, ...rest }: SectionProps) {
  return <tbody {...rest}>{children}</tbody>;
}

function Row({ children, ...rest }: RowProps) {
  return <Table.Row {...rest}>{children}</Table.Row>;
}

function Cell({ children, style, as = 'td', ...rest }: CellProps) {
  return match(as)
    .with('th', () => (
      <Table.HeadCell
        style={{ height: 'auto', background: '#F5F5F5', padding: '8px 16px', lineHeight: 1.4, ...style }}
        {...rest}
      >
        {children}
      </Table.HeadCell>
    ))
    .with('td', () => (
      <Table.Cell style={{ padding: '16px', lineHeight: 1.4, height: 'auto', ...style }} {...rest}>
        {children}
      </Table.Cell>
    ))
    .otherwise(() => null);
}

export const PlainTable = Object.assign(TableRoot, {
  Head,
  Body,
  Row,
  Cell,
});
